const state = {
    geometriesFromServer: []
}

const getters = {
    getGeometriesFromServer: state => {
        return state.geometriesFromServer
    }
}

const mutations = {
    setGeometriesFromServer: state => {
        return state.geometriesFromServer
    }
}

const actions = {
    getGeometriesFromServer: ({ commit }) => {
        // SKAL FIXES
        commit('setGeometriesFromServer', [])
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/asset/asset.js